import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import RefreshCwIcon from "../../../../assets/icons/RefreshCwIcon";

import Message from "../../../../i18n/Message";
import FormActions from "../../store/FormActions";
import { formSelectors } from "../../store/formReducer";

import FormSubmission from "./FormSubmission";

import "./FormSubmissionList.scss";

const FormSubmissionList = ({ endpoint }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const submissions = useSelector(formSelectors.getSubmissions);
  const [showForm, setShowForm] = useState(false);

  const [version, setVersion] = useState("");
  const [showRecordingIndex, setShowRecordingIndex] = useState(null);
  const [showVideoIndex, setShowVideoIndex] = useState(null);
  const promptUid = prompt.uid;
  /*
  const onQuestionAdded = () => {
    const newQuestions = [...questions, { text: question }];
    setQuestions(newQuestions);
    setQuestion("");
  };

  const onQuestionChanged = (index, question) => {
    setQuestions((current) => {
      const newQuestions = current.map((item, idx) =>
        idx === index ? { ...item, text: question } : item
      );
      return newQuestions;
    });
  };

  const onQuestionDeleted = (index) => {
    setQuestions((current) => {
      return current.filter((_, idx) => idx !== index);
    });
  };

  const onRecordingFinished = (questionIdx, asset) => {
    console.log("onRecordingFinished", questionIdx, asset);
    setQuestions((current) => {
      const newQuestions = current.map((item, idx) =>
        idx === questionIdx ? { ...item, vid: asset.uid } : item
      );
      return newQuestions;
    });
    setShowRecordingIndex(null);
  };
  const onVideoQuestionDelete = (questionIdx) => {
    setQuestions((current) => {
      const newQuestions = current.map((item, idx) =>
        idx === questionIdx ? { ...item, vid: null } : item
      );
      return newQuestions;
    });
    setShowVideoIndex(null);
  };
*/

  return (
    <>
      <div className="requests_row card">
        <div className="card_header">
          <div className="card_title">
            <Message id="form_submissions_title" />
          </div>
          <div className="card_actions">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() =>
                dispatch({ type: FormActions.SUBMISSIONS_CHANGED })
              }
            >
              <RefreshCwIcon size="18" color="#cb0c9f" />
              <Message id="refresh_requests" />
            </button>
          </div>
        </div>
        <div className="prompt_versions_body">
          {(submissions ?? []).map((submission, idx) => (
            <FormSubmission
              key={submission.uid}
              submission={submission}
              index={idx}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default FormSubmissionList;
